<template>
    <ec-tabela-listagem
        :url-sistema="urlSistema"
        chave-dados="Filtros"
        rotulo-itens="filtros"
        texto-vazio="Nenhum filtro de inscrição web cadastrado."
        placeholder-busca="Buscar por curso ou ano"
        :link-linha="visualizar ? (filtro => urlSistema + '/' + filtro.id) : null"
    >
        <template v-slot:botaonovo>
            <slot name="botaonovo"></slot>
        </template>

        <template v-slot:celula="{ item, coluna, valor }">
            {{ formatarCelula(item, coluna.nomecampo, valor) }}
        </template>

        <template v-slot:acoes="{ item }">
            <a v-if="visualizar" :href="urlSistema+'/'+item.id" class="btn btn-sm ec-acao" v-b-tooltip.hover title="Visualizar" aria-label="Visualizar"><b-icon icon="eye-fill"></b-icon></a>
        </template>
    </ec-tabela-listagem>
</template>

<script>
export default {
    props:
    {
        urlSistema:{type:String,required:true},
        novo:{type:Boolean,required:true},
        visualizar:{type:Boolean,required:true},
        editar:{type:Boolean,required:true},
        excluir:{type:Boolean,required:true},
        classe:{
            type:String,
            required:false
        }
    },
    methods:{
        formatarCelula(filtro, campo, valor){
            if(campo=='descricaocurso'){
                return filtro.course ? filtro.course.descricaocurso : '—';
            }
            if(campo=='semestre'){
                return valor==null ? 'Todos' : (valor==0 ? 'Anual' : (valor==1 ? '1º Semestre' : '2º Semestre'));
            }
            if(campo=='datainicio' || campo=='datatermino'){
                return this.formatDate(valor) || '—';
            }
            return (valor===null || valor===undefined || valor==='') ? '—' : valor;
        },
        // data do banco (aaaa-mm-dd[ hh:mm:ss]) para dd/mm/aaaa, sem conversão de fuso
        formatDate(date){
            if(!date) return null;
            const [ano, mes, dia] = String(date).substring(0,10).split('-');
            return dia && mes && ano ? [dia, mes, ano].join('/') : null;
        },
    }
}
</script>
